import axios from "./axios";

export function recordSearch({ searchKey, typeId = 1 }) {
  const sessionId = localStorage.getItem("sessionId");
  if (!sessionId || !searchKey?.trim()) return;
  axios
    .post("/SearchHistory/Record", {
      deviceType: "Web",
      sessionId,
      typeId,
      searchKey: searchKey.trim(),
      langKey:
        localStorage.getItem("Lang") === "en"
          ? ""
          : localStorage.getItem("Lang") || "",
    })
    .catch(() => {});
}
